import React from "react";
import { cn } from "../lib/utils";

const BAND_CLASS = {
  A: "epc-a",
  B: "epc-b",
  C: "epc-c",
  D: "epc-d",
  E: "epc-e",
  F: "epc-f",
  G: "epc-g",
};

export function EPCBadge({ band, size = "md", className }) {
  const b = (band || "").toUpperCase();
  const valid = BAND_CLASS[b];
  const sizes = {
    sm: "h-6 w-6 text-xs",
    md: "h-8 w-8 text-sm",
    lg: "h-12 w-12 text-lg",
    xl: "h-20 w-20 text-3xl",
  };
  return (
    <div
      data-testid={`epc-badge-${b || "unknown"}`}
      className={cn(
        "inline-flex items-center justify-center font-black tracking-tight font-heading",
        valid || "bg-slate-200 text-slate-500",
        sizes[size],
        className
      )}
    >
      {valid ? b : "?"}
    </div>
  );
}
